import React, { Component } from 'react'
import MatrixTableEditForm from "./matrix/table.component.jsx"
import {FormattedMessage} from 'react-intl'

class MatrixEditForm extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            defaultUnitPrice: this.props.defaultUnitPrice || '',
            defaultUnitCost: this.props.defaultUnitCost || '',
            pricingStrategy: this.props.pricingStrategy || '',
            currency: this.props.currency || '',
            billingMethods: this.props.billingMethods || [],
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            defaultUnitPrice: nextProps.defaultUnitPrice || '',
            defaultUnitCost: nextProps.defaultUnitCost || '',
            pricingStrategy: nextProps.pricingStrategy || '',
            currency: nextProps.currency || '',
            billingMethods: nextProps.billingMethods || [],
        })
    }

    render() {
        return (
            <div className="col-12 ui-module">
                <h4 className={'custom-lead'}>
                    <FormattedMessage
                        id="product.matrix.form.title"
                        defaultMessage="Matrix configuration"
                    />
                </h4>
                <MatrixTableEditForm
                    defaultUnitPrice={this.state.defaultUnitPrice}
                    defaultUnitCost={this.state.defaultUnitCost}
                    pricingStrategy={this.state.pricingStrategy}
                    billingMethods={this.state.billingMethods}
                    onChange={this.props.onChange}
                    matrix={this.props.matrix}
                    currency={this.props.currency}
                />
            </div>
        );
    }
}

export default MatrixEditForm


// WEBPACK FOOTER //
// ./src/product/form/matrix.component.jsx